import {
    EModalColor,
    useGetModalProperties
} from 'components/site/modals/ModalWrapper/ModalContent/useGetModalProperties';
import { ImageMask } from 'elements/visual/ImageMask';
import { EGrads } from 'libs/styles/styling';
import { useContext } from 'react';
import { CtxModal } from 'session/ctxModal';
import styled, { css } from 'styled-components/macro';

interface Props {
    className?: string;
}

export const ModalContent = (props: Props): JSX.Element => {
    const ctxModal = useContext(CtxModal);
    const getModalPropreties = useGetModalProperties();
    const modal = getModalPropreties.getModal();

    if (!ctxModal.modal) return <></>;

    return (
        <S_ModalContent className={props.className} color={modal.color}>
            {modal.content}
            {modal.color === EModalColor.ORANGE && (
                <ImageMask randomizePosition={true} image="contour" repeat={true} step={20} />
            )}
        </S_ModalContent>
    );
};

const S_ModalContent = styled.div`
    width: 100%;
    height: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    position: relative;
    ${(props) => {
        if (props.color === EModalColor.WHITE) {
            return css`
                background-color: white;
            `;
        } else if (props.color === EModalColor.ORANGE) {
            return css`
                background: ${EGrads.ACC2_GRAD};
            `;
        } else if (props.color === EModalColor.GREY) {
            return css`
                background-color: #efefef;
            `;
        } else if (props.color === EModalColor.GREY2) {
            return css`
                background-color: #f7f9ff;
            `;
        }
    }}
    //hack to keep padding
    &:after {
        content: '';
        display: block;
        height: 0px;
        width: 100%;
    }
    @media only screen and (min-width: 1260px) {
        padding: 0;
        height: unset;
        &::-webkit-scrollbar,
        &::-webkit-scrollbar {
            width: 15px;
        }
        &::-webkit-scrollbar-track {
            background-color: rgba(white, 0.5);
        }
        &::-webkit-scrollbar-thumb {
            background-color: #c7cbd1;
            border-radius: 0px;
            // border: 1px solid white;
        }
    }
`;
